export const BPM_RUNTIME_DEVKIT_LANG_RESOURCES = {
  "zh-CHS": {
    "startProcessSuccess": "流程启动成功",
    "failedToStartProcess": "流程启动失败",
    "moreThanOneProcessCanBeStarted": "流程启动失败，有多条启用的流程"
  },
  "en": {
    "startProcessSuccess": "Started process successfully",
    "failedToStartProcess": "Failed to start process",
    "moreThanOneProcessCanBeStarted": "Failed to start process because there are more than one enabled process."
  },
  "zh-CHT": {
    "startProcessSuccess": "流程啓動成功",
    "failedToStartProcess": "流程啓動失敗",
    "moreThanOneProcessCanBeStarted": "流程啓動失敗，有多條啓用的流程"
  }
};
